module.exports = __webpack_public_path__ + "static/media/deddou.a370de04.jpg";